export default {"src":"/_next/static/media/collaborate_elevate.d242a09b.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};